/**
 * subquerySectionChipHint — pure helper split out of `SubquerySection.tsx` so
 * that component file only exports the component (the `react-refresh/only-
 * export-components` rule this codebase already follows this way — see
 * `SetTableOptionsEngineFields.tsx` for the same split).
 *
 * COM-23/24/25/26 ("the dead-end scalar-subquery chip ... nothing says 'open
 * the full editor to edit this subquery'" — Ralph/VqePolish/findings/
 * FINDINGS-CHECKLIST.md): non-LATERAL chip-mode subqueries (WHERE/HAVING
 * IN-list + scalar, SELECT-list scalar) previously had NO tooltip at all — the
 * `VqeTooltip` `content` prop was `undefined` unless `isLateral`. Every chip
 * summary now teaches: what it is + the next action (open the full editor),
 * which is always true regardless of whether this particular chip ALSO
 * supports inline expand-to-edit. `mode === 'block'` (FROM/JOIN derived
 * tables) is unaffected — those already lead with their alias (COM-21/22) and
 * don't need this hint.
 */

// TODO(vqe-copy): consolidate into vqeCopy.ts once the sole vqeCopy.ts writer
// for this batch (#4) has landed — see task-prim6a-degradedetail-brief.md.
const CHIP_SUBQUERY_HINT =
  'Subquery — expand to view it, or open the full editor to edit this subquery.';

export function chipSubqueryHint(mode: 'block' | 'chip', isLateral: boolean): string | undefined {
  if (mode !== 'chip') return undefined;
  return isLateral ? 'LATERAL subquery' : CHIP_SUBQUERY_HINT;
}
